import React, { useState, useEffect } from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { fi } from "date-fns/locale";
import { format } from "date-fns";

const LocalizedDatePicker = (props: ReactDatePickerProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 1024);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // lokalisoidut kuukaudet
  const months = Array.from({ length: 12 }, (_, i) =>
    format(new Date(2000, i, 1), "LLLL", { locale: fi }),
  );

  return (
    <DatePicker
      locale={fi}
      dateFormat="dd.MM.yyyy"
      withPortal={isMobile}
      customInput={<input inputMode="none" />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 8px",
          }}
        >
          {/* ← oletusnappi */}
          <button
            type="button"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className="react-datepicker__navigation react-datepicker__navigation--previous"
          >
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
              {"<"}
            </span>
          </button>

          {/* kuukausi + vuosi selectit */}
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <select
              value={date.getMonth()}
              onChange={(e) => changeMonth(Number(e.target.value))}
            >
              {months.map((month, index) => (
                <option key={month} value={index}>
                  {month}
                </option>
              ))}
            </select>
            <select
              value={date.getFullYear()}
              onChange={(e) => changeYear(Number(e.target.value))}
            >
              {Array.from({ length: 50 }, (_, i) => {
                const year = new Date().getFullYear() - 25 + i;
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>
          </div>

          {/* → oletusnappi */}
          <button
            type="button"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className="react-datepicker__navigation react-datepicker__navigation--next"
          >
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
              {">"}
            </span>
          </button>
        </div>
      )}
      {...props}
    />
  );
};

export default LocalizedDatePicker;
